import React, { useState } from 'react';

export default function FilterBar({
  serviceTypes, activeTypes, onToggleType,
  timePeriods, timePeriod, onTimePeriodChange,
  statusFilter, onStatusFilterChange,
  searchQuery, onSearchChange,
}) {
  const [showAllTypes, setShowAllTypes] = useState(false);
  const visibleTypes = showAllTypes ? serviceTypes : serviceTypes.slice(0, 8);

  const activeCount = Object.values(activeTypes).filter(Boolean).length;

  return (
    <div className="filter-bar">
      {/* Search */}
      <div className="filter-section filter-search">
        <div className="search-input-wrapper">
          <svg className="search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8" /><path d="M21 21l-4.35-4.35" />
          </svg>
          <input
            type="text"
            className="search-input"
            placeholder="Search patient, doctor, order ID..."
            value={searchQuery}
            onChange={e => onSearchChange(e.target.value)}
          />
          {searchQuery && (
            <button className="search-clear" onClick={() => onSearchChange('')}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 6L6 18M6 6l12 12" /></svg>
            </button>
          )}
        </div>
      </div>

      {/* Service Type Chips */}
      <div className="filter-section">
        <div className="filter-label">
          Services
          <span className="filter-count">{activeCount}/{serviceTypes.length}</span>
        </div>
        <div className="chip-group">
          {visibleTypes.map(type => (
            <button
              key={type.code}
              className={`chip ${activeTypes[type.code] ? 'active' : ''}`}
              onClick={() => onToggleType(type.code)}
              style={activeTypes[type.code] ? { background: type.color, borderColor: type.color } : {}}
            >
              {type.label}
            </button>
          ))}
          {serviceTypes.length > 8 && (
            <button className="chip chip-more" onClick={() => setShowAllTypes(p => !p)}>
              {showAllTypes ? 'Less' : `+${serviceTypes.length - 8} more`}
            </button>
          )}
        </div>
      </div>

      {/* Time Period */}
      <div className="filter-section">
        <div className="filter-label">Period</div>
        <div className="chip-group">
          <button
            className={`chip chip-sm ${!timePeriod ? 'active' : ''}`}
            onClick={() => onTimePeriodChange(null)}
          >All</button>
          {timePeriods.map(tp => (
            <button
              key={tp.value}
              className={`chip chip-sm ${timePeriod === tp.value ? 'active' : ''}`}
              onClick={() => onTimePeriodChange(tp.value === timePeriod ? null : tp.value)}
            >
              {tp.label}
            </button>
          ))}
        </div>
      </div>

      {/* Status Filter */}
      <div className="filter-section">
        <div className="filter-label">Status</div>
        <div className="chip-group">
          {[
            { value: 'all', label: 'All' },
            { value: 'notFinished', label: 'Not Finished' },
            { value: 'pending', label: 'Pending' },
            { value: 'expired', label: 'Expired' },
          ].map(sf => (
            <button
              key={sf.value}
              className={`chip chip-sm ${statusFilter === sf.value ? 'active' : ''}`}
              onClick={() => onStatusFilterChange(sf.value)}
            >
              {sf.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
